"use client"
import { ImageUploadField } from "@/(admin)/modules/ui-builder/config/lib/ImageUploadField"
import { ComponentConfig } from "@measured/puck"
import { commonStylesProps } from "../../lib/commonCSSProps"
import { RenderConfig, SimpleSliderProps } from "./RenderConfig"

export const SimpleSlider: ComponentConfig<SimpleSliderProps> = {
  label: "Simple Slider",
  //@ts-ignore
  fields: {
    slides: {
      label: "Slides",
      type: "array",
      getItemSummary: (slides, index = 0) => `Slide: ${index + 1}`,
      arrayFields: {
        image: {
          label: "Image",
          type: "custom",
          render: props => <ImageUploadField {...props} />,
        },
        url: {
          label: "Link",
          type: "text",
        },
        title: {
          label: "Title",
          type: "text",
        },
        date: {
          label: "Date",
          type: "text",
        },
      },
    },
    spaceBetween: {
      label: "Space Between Slides (px)",
      type: "number",
      min: 0,
    },
    // slidesPerView: {
    //   label: "Slides Per View",
    //   type: "number",
    //   min: 1,
    // },
    loop: {
      label: "Loop",
      type: "select",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    speed: {
      label: "Speed (ms)",
      type: "number",
      min: 0,
    },
    timeDelay: {
      label: "Time Delay (ms)",
      type: "number",
      min: 0,
    },
    pagination: {
      label: "Pagination",
      type: "select",
      options: [
        { label: "Default", value: "default" },
        { label: "Custom", value: "custom" },
      ],
    },
    ...commonStylesProps,
  },
  defaultProps: {
    slides: [
      {
        id: 1,
        url: "",
      },
      {
        id: 2,
        url: "",
      },
    ],
    spaceBetween: 30,
    slidesPerView: 1,
    speed: 600,
    timeDelay: 3500,
    pagination: "default",
    className: "",
    styles: {
      mobile: {
        display: "block",
      },
      tablet: {
        display: "block",
      },
      desktop: {
        display: "block",
      },
    },
  },
  ...RenderConfig,
}
